import { asyncAction } from '../../utils/actions';

export const fetchGroups = asyncAction('devices/FETCH_GROUPS');
